import { styled } from "@mui/material";

export const FormContainer = styled("div")`
  width: 100%;
  & > * {
    margin-top: 0.7em !important;
    margin-bottom: 0.7em !important;
  }
`;
